import { Controller } from "@hotwired/stimulus";

export default class TableStickyHeader extends Controller<HTMLTableElement> {
	connect() {
		document.addEventListener("scroll", this.handleScroll, {
			passive: true,
		});
	}

	handleScroll = () => {
		const top = -1 * Math.min(0, this.element.getBoundingClientRect().top);
		this.element.style.setProperty("--top-offset", `${top}px`);
	};

	disconnect() {
		document.removeEventListener("scroll", this.handleScroll);
	}
}
